<template>
<div >
    <p class="title">项目投标</p>
    <div>
        <img src="../assets/help/1.1.1-6.png" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>